var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Plugin, PluginKey } from 'prosemirror-state';
import { EventChannel } from '../../event';
var pluginKey = new PluginKey('lifecycle');
var emitLifeCycleEvent = function (view, prevState, emitter) {
    var state = view.state;
    if (!prevState.doc.eq(state.doc)) {
        /**
         * TODO
         * since the timing of updating the DOM by libraries such as react and vue is not synchronized.
         * it will make `getHTML()` return lagging content  if trigger the `text-change` event synchronized
         */
        setTimeout(function () { return emitter.emit(EventChannel.LocalEvent.TEXT_CHANGED); });
    }
    if (!prevState.selection.eq(state.selection)) {
        emitter.emit(EventChannel.LocalEvent.SELECTION_CHANGED);
    }
};
var LifeCyclePlugin = /** @class */ (function (_super) {
    __extends(LifeCyclePlugin, _super);
    function LifeCyclePlugin(adapter) {
        var _this = _super.call(this, {
            key: pluginKey,
            view: function () { return ({
                update: function (view, prevState) { return emitLifeCycleEvent(view, prevState, _this.emitter); },
            }); },
        }) || this;
        _this.emitter = adapter.configurator.emitter;
        return _this;
    }
    return LifeCyclePlugin;
}(Plugin));
var createLifeCyclePlugin = function (adapter) { return new LifeCyclePlugin(adapter); };
export { createLifeCyclePlugin, emitLifeCycleEvent };
//# sourceMappingURL=lifecycle-plugin.js.map